module.exports = __webpack_public_path__ + "img/gbwhatsapp-android.8c0499d9.webp";